<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="87.507"
    height="26.371"
    viewBox="0 0 87.507 26.371"
  >
    <g id="Amazon_logo" transform="translate(0 0)">
      <path
        id="path8"
        d="M182.667,196.065c-5.085,3.748-12.456,5.748-18.8,5.748a34.023,34.023,0,0,1-22.969-8.765c-.476-.43-.05-1.017.522-.682a46.229,46.229,0,0,0,22.98,6.095,45.7,45.7,0,0,0,17.53-3.584c.861-.366,1.581.564.739,1.188"
        transform="translate(-128.38 -175.442)"
        fill="#f90"
        fill-rule="evenodd"
      />
      <path
        id="path10"
        d="M578.249,184.109c-.648-.83-4.3-.392-5.935-.2-.5.061-.575-.373-.126-.686,2.906-2.046,7.675-1.455,8.231-.769s-.145,5.47-2.876,7.752c-.419.35-.819.164-.632-.3.613-1.531,1.988-4.963,1.337-5.8"
        transform="translate(-521.847 -165.905)"
        fill="#f90"
        fill-rule="evenodd"
      />
      <path
        id="path12"
        d="M572.743,6.931V4.943a.491.491,0,0,1,.5-.5h8.9a.5.5,0,0,1,.514.5v1.7a2.8,2.8,0,0,1-.67,1.249l-4.613,6.586a9.829,9.829,0,0,1,5.078,1.089.906.906,0,0,1,.472.773v2.122c0,.289-.32.628-.655.453a10.255,10.255,0,0,0-9.4.015c-.309.168-.632-.168-.632-.457V16.462a2.4,2.4,0,0,1,.328-1.367l5.344-7.664h-4.651a.493.493,0,0,1-.514-.5"
        transform="translate(-522.162 -4.051)"
        fill-rule="evenodd"
      />
      <path
        id="path14"
        d="M173.653,16.676h-2.708a.512.512,0,0,1-.484-.461V2.316a.508.508,0,0,1,.522-.5h2.525a.51.51,0,0,1,.491.465V4.1h.05a3.575,3.575,0,0,1,3.565-2.575c1.7,0,2.754.819,3.516,2.575a4,4,0,0,1,6.875-1.055c.857,1.169.682,2.868.682,4.358l0,8.772a.512.512,0,0,1-.522.5h-2.7a.515.515,0,0,1-.488-.5V8.807a17.4,17.4,0,0,0-.076-2.605,1.41,1.41,0,0,0-1.592-1.2,1.8,1.8,0,0,0-1.619,1.139,8.414,8.414,0,0,0-.251,2.663v7.367a.512.512,0,0,1-.522.5h-2.7a.512.512,0,0,1-.488-.5l0-7.367c0-1.55.255-3.832-1.668-3.832-1.946,0-1.87,2.225-1.87,3.832v7.367a.512.512,0,0,1-.522.5"
        transform="translate(-155.545 -1.39)"
        fill-rule="evenodd"
      />
      <path
        id="path16"
        d="M715.406,1.524c4.019,0,6.194,3.451,6.194,7.839,0,4.24-2.4,7.6-6.194,7.6-3.946,0-6.095-3.451-6.095-7.752,0-4.327,2.175-7.691,6.095-7.691m.023,2.838c-2,0-2.122,2.72-2.122,4.415s-.027,5.325,2.1,5.325c2.1,0,2.2-2.925,2.2-4.708a12.85,12.85,0,0,0-.4-3.687,1.694,1.694,0,0,0-1.771-1.345"
        transform="translate(-647.241 -1.39)"
        fill-rule="evenodd"
      />
      <path
        id="path18"
        d="M876.039,16.676h-2.7a.515.515,0,0,1-.488-.5l0-13.9a.512.512,0,0,1,.522-.453h2.51a.518.518,0,0,1,.484.389V4.331h.05c.758-1.9,1.821-2.807,3.691-2.807a3.553,3.553,0,0,1,3.162,1.638c.708,1.112.708,2.983.708,4.327v8.75a.52.52,0,0,1-.522.438H880.74a.513.513,0,0,1-.48-.438V8.689c0-1.52.175-3.744-1.7-3.744A1.77,1.77,0,0,0,877,6.057a6.152,6.152,0,0,0-.43,2.632v7.485a.521.521,0,0,1-.529.5"
        transform="translate(-796.47 -1.39)"
        fill-rule="evenodd"
      />
      <path
        id="path28"
        d="M413.717,8.647a5.3,5.3,0,0,1-.507,2.872,2.2,2.2,0,0,1-1.874,1.23c-1.04,0-1.649-.792-1.649-1.962,0-2.308,2.068-2.727,4.03-2.727v.587m2.731,6.6a.566.566,0,0,1-.64.065,6.6,6.6,0,0,1-1.554-1.806,5.363,5.363,0,0,1-4.464,1.969,3.842,3.842,0,0,1-4.053-4.22,4.6,4.6,0,0,1,2.887-4.426,18.766,18.766,0,0,1,5.093-.941v-.35a3.454,3.454,0,0,0-.331-1.962,1.8,1.8,0,0,0-1.52-.7A2.06,2.06,0,0,0,409.691,4.5a.566.566,0,0,1-.472.5l-2.624-.282a.477.477,0,0,1-.4-.568C406.792.96,409.672,0,412.247,0a6.14,6.14,0,0,1,4.08,1.348c1.318,1.23,1.192,2.872,1.192,4.659v4.22a3.7,3.7,0,0,0,1.021,2.51.512.512,0,0,1-.011.72c-.552.461-1.535,1.318-2.076,1.8l0-.008"
        transform="translate(-370.232)"
        fill-rule="evenodd"
      />
      <path
        id="path30"
        d="M7.98,8.647a5.3,5.3,0,0,1-.507,2.872A2.2,2.2,0,0,1,5.6,12.749c-1.04,0-1.646-.792-1.646-1.962,0-2.308,2.068-2.727,4.026-2.727v.587m2.731,6.6a.566.566,0,0,1-.64.065,6.668,6.668,0,0,1-1.554-1.806,5.359,5.359,0,0,1-4.464,1.969A3.843,3.843,0,0,1,0,11.256,4.6,4.6,0,0,1,2.887,6.83,18.766,18.766,0,0,1,7.98,5.889v-.35a3.485,3.485,0,0,0-.328-1.962,1.812,1.812,0,0,0-1.52-.7A2.064,2.064,0,0,0,3.954,4.5a.567.567,0,0,1-.469.5L.857,4.712a.48.48,0,0,1-.4-.568C1.059.96,3.935,0,6.51,0a6.14,6.14,0,0,1,4.08,1.348c1.318,1.23,1.192,2.872,1.192,4.659v4.22a3.7,3.7,0,0,0,1.021,2.51.509.509,0,0,1-.008.72c-.552.461-1.535,1.318-2.076,1.8l-.008-.008"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>